// src/components/IntegrationsSkeleton.tsx
import React from "react";
import { withTranslation } from "react-i18next";
import { Row, Col, Card, CardHeader, CardBody, Badge } from "reactstrap";

const PLACEHOLDER_COUNT = 8;

const IntegrationsSkeleton: React.FC<any> = ({ t }) => (
  <div>
    <p className="text-muted mb-4">
      {t(
        "integrations.subtitle",
        "Connect your apps to bring all your data into one central place."
      )}
    </p>
    <Row className="gx-4 gy-4">
      {Array.from({ length: PLACEHOLDER_COUNT }).map((_, idx) => (
        <Col key={idx} xs={12} sm={6} md={4} lg={3}>
          <Card className="h-100 shadow-sm rounded">
            {/* header */}
            <CardHeader className="d-flex align-items-center justify-content-between bg-light p-3">
              <div className="d-flex align-items-center w-75 placeholder-glow">
                {/* perfect circle */}
                <span
                  className="placeholder rounded-circle d-inline-block flex-shrink-0"
                  style={{
                    width: 40,
                    height: 40,
                  }}
                />
                <div className="ms-3 w-100">
                  <span className="placeholder col-6 d-block mb-1" />
                  <span className="placeholder col-4 d-block" />
                </div>
              </div>
            </CardHeader>

            {/* body */}
            <CardBody className="d-flex flex-column p-3">
              <div className="placeholder-glow mb-4">
                <span
                  className="placeholder w-100"
                  style={{
                    height: 64,
                    borderRadius: 4,
                    display: "block",
                  }}
                />
              </div>

              <div className="mt-auto d-flex gap-2 placeholder-glow">
                <span
                  className="placeholder flex-fill"
                  style={{ height: "2rem" }}
                />
                <span
                  className="placeholder flex-fill"
                  style={{ height: "2rem" }}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  </div>
);

export default withTranslation()(IntegrationsSkeleton);
